import { Action } from '@ngrx/store';
import { PricePlanSearchRequest } from '../lib/price-plan-search-request';
import { PricePlanListState, PricePlanState } from './price-plans.reducer';

export enum PricePlansActionTypes {
  LoadPricePlanList = '[PricePlans] Load PricePlanList',
  LoadPricePlan = '[PricePlans] Load PricePlan',

  ResetPricePlanListState = '[PricePlans] Reset PricePlanList State',
  ResetPricePlanListPayload = '[PricePlans] Reset PricePlanList Payload',
  ResetPricePlanState = '[PricePlans] Reset PricePlan State',

  SetPricePlanListState = '[PricePlans] Set PricePlanList State',
  SetPricePlanState = '[PricePlans] Set PricePlan State',
}

export class LoadPricePlanList implements Action {
  readonly type = PricePlansActionTypes.LoadPricePlanList;

  constructor(public searchRequest: PricePlanSearchRequest, public forced: boolean = false) {}
}

export class LoadPricePlan implements Action {
  readonly type = PricePlansActionTypes.LoadPricePlan;

  constructor(public id: string, public forced: boolean = false) {}
}

export class ResetPricePlanListState implements Action {
  readonly type = PricePlansActionTypes.ResetPricePlanListState;
}

export class ResetPricePlanListPayload implements Action {
  readonly type = PricePlansActionTypes.ResetPricePlanListPayload;
}

export class ResetPricePlanState implements Action {
  readonly type = PricePlansActionTypes.ResetPricePlanState;
}

export class SetPricePlanListState implements Action {
  readonly type = PricePlansActionTypes.SetPricePlanListState;

  constructor(public payload: PricePlanListState) {}
}

export class SetPricePlanState implements Action {
  readonly type = PricePlansActionTypes.SetPricePlanState;

  constructor(public payload: PricePlanState) {}
}

export type PricePlansActions =
  | LoadPricePlanList
  | LoadPricePlan
  | ResetPricePlanListState
  | ResetPricePlanListPayload
  | ResetPricePlanState
  | SetPricePlanListState
  | SetPricePlanState;
